@if (loader.getLoading()) {
<div class="loader">
  <ng-lottie [options]="options"></ng-lottie>
</div>
}
